module.exports = __webpack_public_path__ + "img/jjooJuventud5.64563b1d.jpg";